<template>
  <div class="row">
    <div class="col-xs-12" v-if="$user.isSe()">
      <lea-static-box></lea-static-box>
    </div>
    <div class="col-xs-12" v-else>
      <div style="margin-top: 80px" class="text-center">
        <div class="font-bold" style="font-size: 16px">Start with 2-3 keywords</div>
        <div class="font-bold" style="font-size: 16px">Explore the results and the suggestions to refine</div>
      </div>
    </div>
  </div>
</template>

<script>
import LeaStaticBox from './LeaStaticBox'

export default {
  components: {LeaStaticBox},
  name: 'WelcomeStaticBox'
}
</script>



// WEBPACK FOOTER //
// src/components/simpleInterface/WelcomeStaticBox.vue